// @gs/feedback/client — dispatch de rendu d'une PJ (helper PUR, teste sans DOM
// — pattern filterTickets.ts). CHORE-FBK-PJ-PREVIEW, norme industrie
// (GitHub/Linear/Slack) : image = vignette + lightbox ; PDF = onglet
// (visualisateur NATIF navigateur) ; le reste = telechargement direct.

export type AttachmentKind = 'image' | 'pdf' | 'other';

export function attachmentKind(contentType: string): AttachmentKind {
  if (/^image\//.test(contentType)) return 'image';
  if (contentType === 'application/pdf') return 'pdf';
  return 'other';
}
